import { Communes, Office, Regions } from './../models/index';
import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});

export default class Utils {
  static formatDate(date: Date, format: string = 'year'): string {
    if (!date) {
      return '';
    }
    const newDate = new Date(date);
    const year = newDate?.getFullYear().toString().slice(-4);
    const month = ('0' + (newDate.getMonth() + 1)).slice(-2);
    const day = ('0' + newDate.getDate()).slice(-2);

    if (format === 'day') {
      return `${day}-${month}-${year}`;
    }
    return `${year}-${month}-${day}`;
  }

  static fromBase64(data: any) {
    return atob(data);
  }

  static toBase64(data: any) {
    const stringData = JSON.stringify(data);
    return btoa(stringData);
  }

  static saveToLocalStorage(key: any, data: any) {
    const stringData = JSON.stringify(data);
    localStorage.setItem(key, this.toBase64(stringData));
  }

  static loadFromLocalStorage(key: any) {
    if (!localStorage.getItem(key)) {
      return {};
    }
    const decoded = JSON.parse(this.fromBase64(localStorage.getItem(key)));
    return decoded;
  }

  static getOffice(
    index: number,
    storedStep: any,
    regionsCache: Regions[]
  ): Office | undefined {
    if (!storedStep) {
      return undefined;
    }
    const region = regionsCache.find(
      (region: Regions) => region.region === storedStep.region
    );
    const comunas = region && region.comunas;
    const commune =
      comunas &&
      comunas.find((comuna: Communes) => comuna.comuna === storedStep.commune);
    const offices = commune && commune.oficinas;
    const office = offices?.find(
      (office) => office.idOfi === storedStep.office
    );
    return office;
  }

  static getOriginFromURL(
    urlString: string,
    validOrigins: Set<string>
  ): string {
    try {
      const url = new URL(urlString);
      const pathname = url.pathname;

      // Extraer segmentos del pathname
      const relevantPaths = pathname
        .split('/')
        .filter((path) => path !== '' && validOrigins.has(path));

      for (const segment of relevantPaths) {
        if (validOrigins.has(segment)) {
          return segment;
        }
      }

      return 'personas'; // Valor por defecto si no se encuentra ninguno
    } catch (error) {
      console.error('Error al procesar la URL:', error);
      return '';
    }
  }

  static redirigirA(url: string) {
    window.parent.location.href = url;
  }
}
